import React, { Component } from "react";
import {Link} from "react-router-dom";


import gallery1Img from "../../../assets/images/gallary/MachiningWorks/0212-MMT-Alpha_4_2_228_L_inProcess.jpg"
import gallery2Img from "../../../assets/images/gallary/MachiningWorks/istockphoto-680194864-612x612.jpg"
import gallery3Img from "../../../assets/images/gallary/MachiningWorks/machining3.jpg"
import gallery4Img from "../../../assets/images/gallary/MachiningWorks/modern-machining-tools-min.jpg"
import gallery5Img from "../../../assets/images/gallary/MachiningWorks/Pulley for Bucket Elevator.jpg"


import { SRLWrapper } from "simple-react-lightbox";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class Product4 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:new Date(),
        };
    }
    changeDatepickerHandeller=(date)=>{
        this.setState({ startDate: date });
    }

    componentDidMount(){
        this.scrollTop();
    }

    scrollTop()
    {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
  render() {
        const startDate =this.state.startDate;

    return (
        <>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Machining Works</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Machining Works</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            <div className="package-details-wrapper pt-20">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="package-details">

                                <div className="package-tab">



                                    <div className="tab-content p-tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                            <div className="tab-contant-3">
                                                <SRLWrapper>
                                                <div className="row">

                                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                                             <Link to={gallery1Img} >
                                                                    <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery1Img} alt="0212-MMT-Alpha_4_2_228_L_inProces" />
                                                                </Link>

                                                                <Link to={gallery2Img} >
                                                                       <img width="150" height="150" style={{marginRight:10, marginTop:10}}  src={gallery2Img} alt="istockphoto-680194864-612x612" />
                                                                   </Link>

                                                                   <Link to={gallery3Img} >
                                                                          <img width="150" height="150" style={{marginRight:10, marginTop:10}}src={gallery3Img} alt="Machining" />
                                                                      </Link>

                                                                      <Link to={gallery4Img} >
                                                                             <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery4Img} alt="Modern Machining Tools" />
                                                                         </Link>

                                                                         <Link to={gallery5Img} >
                                                                                <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery5Img} alt="Pulley for Bucket Elevator" />
                                                                            </Link>


                                                                                                                                               </div>

                                                                                                                                           </div>
                                                                                                                                           </SRLWrapper><br/>
                                                                                                                                       </div>
                                                                                                                                   </div>
                                                                                                                               </div>
                                                                                                                           </div>
                                                                                                                       </div>
                                                                                                                   </div>

                                                                                                               </div>
                                                                                                           </div>
                                                                                                       </div>
                                                                                                   </>
                                                                                               );
                                                                                             }
                                                                                           }

   export default Product4;
